exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-meeting-plugin,#asseco-meeting .asseco-floaty-btn{background-color:#00897b}", ""]);

// exports
